import axios from 'axios'
import UEapi from '../UEapi/UEapi'
import Store from '../../store'
import MapLayerContral from './MapLayerContral'
import cameraList from '../../utils/configs/cameraList'
import { getName, guid } from '../common/commonHelper'
import layerMap from '@/utils/configs/layerMap'
export default class ObjectManager {
  static appVm = null
  static levelMapper = {
    园区: -0.74,
    楼层_停车场: -0.74,
    楼层_大厅: -0.418,
    楼层_F1: -0.418,
    楼层_F2: 5.295693,
    楼层_F3: 9.722167,
    楼层_F4: 14.34248,
    楼层_F5: 18.84247,
    楼层_F6: 27.31737,
    楼层_F7: 27.84247,
    楼层_F8: 32.34246,
    楼层_F9: 36.84246,
    楼层_F10: 41.36366,
    楼层_F11: 45.86366,
    楼层_F12: 50.36366,
    楼层_F13: 54.86366,
    楼层_F14: 59.34366,
  }

  // prettier-ignore
  static Box = [
    {
      "id": "Box_A01-001-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-001-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-002-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-003-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_A01-004-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-001-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-002-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-003-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_D04-004-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-09_机柜容",
      "isVisible": true
    },
    {
      "id": "Box_B02-001-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-002-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-003-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_B02-004-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-001-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-002-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-003-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_E05-004-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-001-10_机柜容量副",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-002-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-003-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_C03-004-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-001-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-002-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-003-10_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-02_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-01_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-03_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-04_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-05_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-06_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-07_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-08_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-09_机柜容量",
      "isVisible": true
    },
    {
      "id": "Box_F06-004-10_机柜容量",
      "isVisible": true
    }

  ]
  static BoxZ = [
    {
      "id": "A01-003_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "A01-001_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "B02-001_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "B02-002_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "C03-001_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "C03-002_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "A01-002_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "B02-003_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "C03-003_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "C03-004_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "B02-004_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "A01-004_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "D04-001_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "D04-002_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "D04-003_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "D04-004_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "E05-001_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "E05-002_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "E05-003_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "E05-004_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "F06-001_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "F06-002_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "F06-003_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "F06-004_SM_机柜组",
      "isVisible": true
    },
    {
      "id": "G07-001_SM_机柜组",
      "isVisible": false
    },
    {
      "id": "G07-002_SM_机柜组",
      "isVisible": false
    }
  ]
  static linkList = ['Link_SM_机柜通讯线C03', 'Link_SM_机柜通讯线CF01', 'Link_SM_机柜通讯线CF02', 'Link_SM_机柜通讯线F06'];
  static linkList_2 = ['Link_SM_机柜通讯线C03', 'SM_机柜通讯线CA01', 'Link_SM_机柜通讯线CA', 'Link_SM_机柜通讯线A01']

  static getSpaceList(buildList) {
    let { data } = buildList
    const OBJECT_TYPE = 'space'
    const IS_SELECT = false
    // 数据分组
    let buildGroup = {
      l1: [],
      l2: [],
      l3: [],
    }
    for (let i = 0; i < data.length; i++) {
      if (data[i].id === '备份位置building01_G1') {
        continue
      }
      let currentId = data[i].id
      if (!currentId.includes('_')) {
        buildGroup['l1'].push(data[i])
      } else {
        const currentIdSplit = currentId.split('_')
        if (currentIdSplit.length <= 2) {
          buildGroup['l2'].push(data[i])
        } else {
          buildGroup['l3'].push(data[i])
        }
      }
    }

    let l3Data = []
    const stair = []
    const exit = []
    const corridor = []
    const Office = []
    const lift = []
    let officeStartNum = 601
    for (let i = 0; i < buildGroup['l3'].length; i++) {
      // stair 楼梯  exit 出口 corridor 走廊  Office 办公室 lift 电梯
      let name = ''
      let name1 = ''
      let num = ''
      let currentId = buildGroup['l3'][i].id
      if (currentId.includes('stair')) {
        name = '楼梯'
        num = currentId.replace(/(.*?)_stair/, '')
        stair.push({
          id: currentId,
          label: `${name}${num}`,
          num: '',
          category: name,
          children: [],
          sort: num,
          level: '3',
          isSelect: IS_SELECT,
          objType: OBJECT_TYPE,
        })
      } else if (currentId.includes('exit')) {
        name = '出口'
        num = currentId.replace(/(.*?)_exit/, '')
        exit.push({
          id: currentId,
          label: `${name}${num}`,
          num: '',
          category: name,
          children: [],
          sort: num,
          level: '3',
          isSelect: IS_SELECT,
          objType: OBJECT_TYPE,
        })
      } else if (currentId.includes('corridor')) {
        name = '走廊'
        num = currentId.replace(/(.*?)_corridor/, '')
        corridor.push({
          id: currentId,
          label: `${name}${num}`,
          num: '',
          category: name,
          children: [],
          sort: num,
          level: '3',
          isSelect: IS_SELECT,
          objType: OBJECT_TYPE,
        })
      } else if (currentId.includes('Office')) {
        name = '办公室'
        name1 = '会议室'
        num = currentId.replace(/(.*?)_Office/, '')
        Office.push({
          id: currentId,
          label: `${officeStartNum}-${officeStartNum > 636 ? name1 : name}`,
          num: '',
          category: `${officeStartNum > 636 ? name1 : name}`,
          children: [],
          sort: officeStartNum,
          level: '3',
          isSelect: IS_SELECT,
          objType: OBJECT_TYPE,
        })
        officeStartNum++
      } else if (currentId.includes('lift')) {
        name = '电梯'
        num = currentId.replace(/(.*?)_lift/, '')
        lift.push({
          id: currentId,
          label: `${name}${num}`,
          num: '',
          category: name,
          children: [],
          sort: num,
          level: '3',
          isSelect: IS_SELECT,
          objType: OBJECT_TYPE,
        })
      }
    }
    stair.sort((a, b) => a.sort - b.sort)
    exit.sort((a, b) => a.sort - b.sort)
    corridor.sort((a, b) => a.sort - b.sort)
    Office.sort((a, b) => a.sort - b.sort)
    lift.sort((a, b) => a.sort - b.sort)
    l3Data = [...Office, ...stair, ...exit, ...corridor, ...lift]

    let l2Data = []
    for (let i = 0; i < buildGroup['l2'].length; i++) {
      let currentId = buildGroup['l2'][i].id
      let name = 'F'
      let num = currentId.replace('building01_floor', '')
      let temp = {}
      if (num == '6') {
        temp = {
          id: currentId,
          label: `${name}${num}`,
          floor: num,
          num: l3Data.length,
          children: l3Data,
          sort: num,
          level: '2',
          isSelect: IS_SELECT,
          objType: OBJECT_TYPE,
        }
      } else {
        temp = {
          id: currentId,
          label: `${name}${num}`,
          floor: num,
          num: 0,
          children: [],
          sort: num,
          level: '2',
          isSelect: IS_SELECT,
          objType: OBJECT_TYPE,
        }
      }
      l2Data.push(temp)
    }
    l2Data.sort((a, b) => {
      return b.sort - a.sort
    })
    // 添加B1层
    l2Data.push({
      id: 'B1',
      label: `B1`,
      floor: -1,
      num: 0,
      children: [],
      sort: -1,
      level: '2',
      isSelect: IS_SELECT,
      objType: OBJECT_TYPE,
    })

    let l1Data = []
    for (let i = 0; i < buildGroup['l1'].length; i++) {
      let currentId = buildGroup['l1'][i].id
      let name = 'G'
      let num = 5
      let temp = {}
      temp = {
        id: currentId,
        label: `${name}${num}栋`,
        num: l3Data.length + l2Data.length,
        children: l2Data,
        level: '1',
        sort: 1,
        isSelect: IS_SELECT,
        objType: OBJECT_TYPE,
      }
      l1Data.push(temp)
    }

    // let testArr = ['G6', 'G7', 'G8', 'G9', 'G10']
    // testArr.forEach((item) => {
    //   l1Data.push({
    //     id: item,
    //     label: `${item}栋`,
    //     num: 0,
    //     children: [],
    //     level: '1',
    //     sort: 1,
    //     isSelect: IS_SELECT,
    //     objType: OBJECT_TYPE,
    //   })
    // })

    return l1Data
  }

  static getDeviceList(allList, filterType) {
    const OBJECT_TYPE = 'device'
    const IS_SELECT = false
    /* 
    门禁 | 车辆闸机 | 摄像头 | 水表 | 电表 | 燃气表 | 空调 | 可燃气体探测器
    */
    const deviceNameList = [
      { name: '门禁设备', components: 'MenJinSheBei', iconName: "menjinshijian" },
      { name: '消防烟感', components: 'XiaoFangYanGan', iconName: "xiaofangyangan" },
      { name: '固定摄像头', components: 'SheXiangTouGuDing', iconName: "shexiangtouguding" },
      { name: '云台摄像头', components: 'SheXiangTouYunTai', iconName: "shexiangtouyuntai" },
      { name: '人脸识别摄像头', components: 'SheXiangTouRenLianShiBie', iconName: "shexiangtourenlianshibie" },
      { name: '水表设备', components: 'ShuiBiaoSheBei', iconName: "shuibiaoshebei" },
      { name: '电表设备', components: 'DianBiaoSheBei', iconName: "dianbiaoshebei" },
      { name: '空调', components: 'KongTiao', iconName: "kongtiao" },
      { name: '可燃气体探测器', components: 'KeRanQiTiTanCeQi', iconName: "keranqititanceqi" },
      { name: '环境监测设备', components: 'HuanJingJianCeSheBei', iconName: "huanjingjianceshebei" },
    ]

    let deviceData = deviceNameList.map((item) => {
      let components = item.components;
      let iconName = item.iconName;
      let idLayer = item.name
      let curData = allList[item.name].RECORDS
      let filterData = curData.filter((item) => item.type === filterType)
      return {
        id: item.name,
        label: item.name,
        num: filterData.length,
        children: filterData.map((item) => {
          return {
            ...item,
            label: item.name,
            num: '',
            children: [],
            objType: OBJECT_TYPE,
            isSelect: IS_SELECT,
            isLayer: false,
            components: components,
            iconName: iconName,
            idLayer: idLayer
          }
        }),
        objType: OBJECT_TYPE,
        isSelect: IS_SELECT,
        isLayer: true,
        components: ''
      }
    })
    return deviceData
  }

  static getAssetList() {
    const OBJECT_TYPE = 'asset'
    const IS_SELECT = false
    /* 
    笔记本 | 计算机 | 显示器 | 便携机 | 工作站
    */
    const assetNameList = ['笔记本', '计算机', '显示器', '便携机', '工作站']

    let assetData = assetNameList.map((item) => {
      return {
        id: item,
        label: item,
        num: 0,
        children: [],
        objType: OBJECT_TYPE,
        isSelect: IS_SELECT,
      }
    })
    return assetData
  }

  // 缓存轨迹id对应的模拟姓名
  static nameSet = {}

  static getPersonnelList(allList, filterType) {
    const OBJECT_TYPE = 'personnel'
    const IS_SELECT = false
    /* 
    安保人员 | 巡检人员 
    */
    const personnelNameList = [
      { name: '安保人员', components: 'AnBaoRenYuan', iconName: "anbaorenyuan" },
      { name: '巡检人员', components: 'XunJianRenYuan', iconName: "xunjianrenyuan" },
    ]
    let personnelData = personnelNameList.map((item) => {
      const dataSet = {}
      let curData = allList[item.name]?.RECORDS ?? null
      let filterData = curData.filter((item) => item.type === filterType)
      filterData &&
        filterData.forEach((item) => {
          // 给相同数据起个名字
          let name = ObjectManager.nameSet[item.name]
          if (!name) {
            ObjectManager.nameSet[item.name] = getName()
            name = ObjectManager.nameSet[item.name]
          }

          if (dataSet[name]) {
            dataSet[name].push({ label: name, ...item })
          } else {
            dataSet[name] = []
            dataSet[name].push({ label: name, ...item })
          }
        })

      const children = []
      for (let name in dataSet) {
        children.push({
          id: dataSet[name][0].name, // 用原数据的唯一name
          ids: dataSet[name][0].name,
          label: name, // 给原数据唯一name起的姓名
          num: '',
          data: dataSet[name],
          children: [],
          objType: OBJECT_TYPE,
          isSelect: IS_SELECT,
          isLayer: false,
          components: item.components,
          iconName: item.iconName
        })
      }

      return {
        id: item.name,
        ids: item.name,
        label: item.name,
        num: children.length,
        data: [],
        children: children,
        objType: OBJECT_TYPE,
        isSelect: IS_SELECT,
        isLayer: true,
      }
    })
    return personnelData
  }

  static execSpaceModule(node, curTreeRef) {
    console.log('空间', node)
    const curNode = curTreeRef.getNode(node)
    const { level, id, floor, isSelect, components, label, spaceLevel, highLight, num } = node
    if (highLight && isSelect) {
      Store.commit('setHighLight', highLight)
    } else {
      Store.commit('setHighLight', curNode.parent.data.highLight)
    }
    if (isSelect && components) {
      Store.commit('setRightComponents', components)
    } else {
      Store.commit('setRightComponents', '')
    }
    switch (level) {
      case '1':
        if (!isSelect) return
        break
      case '2':
        if (!isSelect) return
        break
      case '3':
        if (!isSelect) return

        setTimeout(() => {
          UEapi.Camera.setCamera(cameraList[label])
        }, 100);
        break
      case '4':
        if (!isSelect) {
          UEapi.Common.switchState({ name: '默认状态' })
          setTimeout(() => {
            UEapi.Camera.setCamera(cameraList['分数据中心-01'])
          }, 100);
          return
        }
        UEapi.Camera.setCamera(cameraList['建筑01'])
        UEapi.Model.setModelVisibility({
          ids: ['SM_IDC建筑标示_建筑'],
          visible: true,
        })
        break
      case '5':
        if (!isSelect) {
          UEapi.Common.switchState({ name: '默认状态' })
          setTimeout(() => {
            UEapi.Camera.setCamera(cameraList['建筑01'])
          }, 500);
          return
        }
        UEapi.Common.switchState({ name: 'IDC机房_内部设施' })
        UEapi.Model.setModelVisibility({
          ids: ['SM_IDC建筑标示_建筑'],
          visible: false,
        })
        setTimeout(() => {
          UEapi.Camera.setCamera(cameraList[label])
        }, 100);
        break
      case '6':
        if (!isSelect) {
          window.layerConfig.recoverDefaultState()
          UEapi.Camera.setCamera(cameraList[curNode.parent.data.label])
          return
        }
        UEapi.Camera.setCamera(cameraList[label])
        break
      case '7':
        if (!isSelect) {
          UEapi.Camera.setCamera(cameraList['机柜组机房'])
          window.layerConfig.recoverDefaultState()
          return
        }
        window.layerConfig.equipmentCabinetOnlyHighlight(id)
        break
      case '8':
        if (!isSelect) {
          window.layerConfig.equipmentCabinetOnlyHighlight(curNode.parent.data.id)
          UEapi.Model.playAnimation({
            id: id,
            name: '机柜_前_关',
            state: 'begin'
          })
          UEapi.Model.playAnimation({
            id: id,
            name: '机柜_后_关',
            state: 'begin'
          })
          return
        }
        window.layerConfig.focusJiGui(id)
        break
      case '9':
        if (!isSelect) {
          window.layerConfig.modelOnlyHighlight()
          UEapi.Camera.setCamera(cameraList[curNode.parent.data.id])
          return
        }
        window.layerConfig.modelOnlyHighlight(id)
        UEapi.Camera.setCamera(cameraList[id])
        break
      default:
        break
    }
  }

  static layer = []

  /**
   * @description: 点击设备树节点执行
   * @param {*} node 当前节点数据
   * @param {*} curTreeRef 设备树vue ref实例
   * @return {*}
   */
  static execDeviceModule(node, curTreeRef) {
    console.log('点击的设备节点', node)
    const { children, id, isLayer, isSelect, components, label, idLayer } = node
    if (isSelect && components) {
      idLayer == '门禁设备' ?
        Store.commit('setObjectInfo', { showName: `园区-门禁设施`, idObj: id })
        : Store.commit('setObjectInfo', { showName: `园区-${idLayer}` })
    } else {
      Store.commit('setObjectInfo', {})
    }
    const curNode = curTreeRef.getNode(node)
    // 右侧对象详情互斥属性设置
    if (!children.length) {
      UEapi.Camera.focusByLayer({
        id: id,
        idLayer: `园区-${idLayer}`,
        layerType: 'landmarkLayer',
        distance: 15
      })
    }
    if (isLayer) {
      if (!isSelect) {
        // ObjectManager.resetCamera()
        return
      }
      window.layerConfig.hideAllLayer()
      let iconName = ''
      // 判断是否有子元素 可以添加图层
      if (children.length > 0) {
        let data = children.map((child) => {
          iconName = child.iconName
          return {
            id: child.id,
            label: '',
            coord: [child.lon, child.lat],
            coordZ: child.coordZ,
            type: id,
          }
        })
        if (isSelect) {
          layerMap['园区'][`园区-${id}`].layerConfig.rawData = data
          window.layerConfig.legendClick({
            txt: id,
            img: `/img/legend/${iconName}`,
            highlight: true,
            layers: [`园区-${id}`]
          })
        } else {
          window.layerConfig.legendClick({
            txt: id,
            img: `/img/legend/${iconName}`,
            highlight: false,
            layers: [`园区-${id}`]
          })
        }
      }
    } else {
      if (!isSelect) {
        // 恢复当前默认相机视角
        // ObjectManager.resetCamera()
        return
      }
    }
  }

  /**
   * @description: 点击人员树节点执行
   * @param {*} node 当前节点数据
   * @param {*} curTreeRef 人员树vue ref实例
   * @return {*}
   */
  static execPersonnelModule(node, curTreeRef) {
    const { children, id, isLayer, isSelect, components, label } = node
    if (isSelect && components) {
      // Store.commit('setRightComponents', components)
      // Store.commit('setObjectInfo', { showName: `园区-${idLayer}` })
    } else {
      // Store.commit('setRightComponents', '')
      // Store.commit('setObjectInfo', {})
    }
    const curNode = curTreeRef.getNode(node)
    if (isLayer) {
      window.layerConfig.hideAllLayer()
      let layer = Store.state.spaceLevel == '园区' ? `园区-${id}` : `园区-${id}1`
      window.layerConfig.legendClick({
        txt: id,
        highlight: isSelect,
        layers: [layer]
      })
    } else {
      // 聚焦
      let parentid = curNode?.parent?.data?.id
      let layerId = Store.state.spaceLevel == '园区' ? `园区-${parentid}` : `园区-${parentid}1`
      let params = {
        id: id,
        idLayer: layerId,
        layerType: 'trailLayer',
        distance: 20,
      }
      UEapi.Camera.focusByLayer(params)
    }
  }

  static resetCamera() {
    // const { cameraLevel, floor } = Store.state
    // if (cameraLevel == '楼层') {
    //   UEapi.Camera.focusFloor({
    //     buildingId: 'building01',
    //     floor: floor,
    //     distance: 80,
    //   })
    // } else {
    //   UEapi.Camera.setCamera(cameraList[cameraLevel])
    // }
    UEapi.Camera.setCamera(cameraList[Store.state.objectInfo.name])
  }

  static addTrackLayer(id, data) {
    data.forEach((pointsLayer) => {
      let jsonData = {
        id: pointsLayer.id,
        name: pointsLayer.id,
        legends: pointsLayer.data.map((item, index) => {
          return {
            name: item.pid,
            color: '#ff0000',
            // icon: 'custom-重点人员',
            icon: 'camera',
            lineColor: '#00ff00',
            lineWidth: 3,
            lineType: 'arrow', //default 波浪线型, arrow 箭头型, dot 虚线型, ray 射线型
            lineSpeed: 1,
            curvature: 0.5,
          }
        }),
        data: pointsLayer.data.map((item, index) => {
          return {
            id: pointsLayer.id,
            label: '',
            coord: item.coord,
            coordZ: this.coordZ,
            type: item.pid,
            time: '2021-07-22 19:45:5',
          }
        }),
      }
      UEapi.TrackLayer.addTrackLayer(jsonData)
    })
  }

  static getCoordZ() {
    const { spaceLevel, floor } = Store.state
    let coordZList = {
      默认场景: 100000,
      中国: 100000,
      北京: 2000,
      园区: 2,
      楼层: 10,
      房间: 10,
      机柜组机房: 10,
      电池组机房: 10,
      UPS设备机房: 10,
      机柜: 10,
    }
    return coordZList[spaceLevel]
    // if (spaceLevel !== '楼层_默认') {
    //   return ObjectManager.levelMapper[spaceLevel]
    // } else {
    //   return ObjectManager.levelMapper[`楼层_F${floor}`]
    // }
  }
}
